<template>
  <div class="">
    <FilePond
      name="file"
      ref="pond"
      :label-idle="labelIdle"
      :allow-multiple="true"
      :allow-revert="false"
      :accepted-file-types="acceptedFileTypes"
      :onprocessfilestart="onProcessFileStart"
      :onprocessfile="onProcessFile"
      :onprocessfiles="onProcessFiles"
      :instant-upload="true"
      :server="serverOptions"
    />
  </div>
</template>

<script>
import vueFilePond from 'vue-filepond';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';

// Import FilePond styles
import 'filepond/dist/filepond.min.css';
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css';
import { getCookie } from '@/utils/helpers';

const FilePond = vueFilePond(FilePondPluginFileValidateType, FilePondPluginImagePreview);

export default {
  name: 'CreateMediaAssets',

  components: {
    FilePond,
  },

  props: {
    taskId: {
      type: String,
      required: true,
    },
    acceptedFileTypes: {
      type: String,
      default: [
        'image/*',
        'application/pdf',
        'video/mp4',
        'application/msword',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'application/vnd.ms-powerpoint',
        'application/vnd.openxmlformats-officedocument.presentationml.presentation',
        'application/vnd.ms-excel',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      ].join(','),
    },
  },

  data() {
    return {
      labelIdle:
        "Drop files here or <span class='underline cursor-pointer'>Browse</span> to upload",
      serverOptions: {
        process: {
          url: `/api/v1/tasks/${this.taskId}/media`,
          method: 'POST',
          withCredentials: true,
          headers: {
            'X-Xsrf-Token': getCookie('XSRF-TOKEN'),
          },
          onload: async (response) => {
            const { data = null } = JSON.parse(response);

            if (!data) {
              return;
            }

            try {
              await this.$store.dispatch({
                type: 'ui/taskMedia/save',
                taskId: this.taskId,
                medium: data,
              });
            } catch (error) {
              //
            }
          },
          onerror: null,
        },
        revert: null,
        restore: null,
        load: null,
        fetch: null,
      },
    };
  },

  methods: {
    onProcessFileStart() {
      this.$emit('uploading');
    },
    onProcessFile(error, file) {
      if (error || typeof this.$refs.pond === 'undefined') {
        return;
      }

      this.$refs.pond.removeFile(file.id);
    },
    onProcessFiles() {
      this.$emit('uploaded');
    },
  },
};
</script>

<style>
.filepond--root {
  @apply mb-0;
}
</style>
